import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import { Stack } from '@mui/system';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';

type RefundConfirmationDialogProps = {
  onClose: () => void;
  proceed: () => void;
};

const RefundConfirmationDialog: FC<RefundConfirmationDialogProps> = ({
  onClose,
  proceed,
}) => {
  const { t } = useTranslation(['payments', 'common']);

  return (
    <ModalNotification
      size='xs'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: t('payments:issue_refund_confirmation_title'),
        content: (
          <Stack sx={{ py: 1 }}>
            <Typography variant='body1'>
              {t('payments:issue_refund_confirmation_text')}
            </Typography>
          </Stack>
        ),
        actions: [
          {
            label: t('common:cancel'),
            onClick: onClose,
          },
          {
            label: t('payments:issue_refund'),
            variant: 'contained',
            color: 'error',
            onClick: proceed,
          },
        ],
      }}
    />
  );
};

export default RefundConfirmationDialog;
